import React, { useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';

// Packages
import PropTypes from 'prop-types';

// Utils
import { epochToLocalDate, cycleDaysInfo } from '../../utils/datesHandler';

const CycleDatesInfo = (props) => {
	const { cycle } = props;

	const { global_data } = useSelector(state => state.global);

	const [daysInfo, setDaysInfo] = useState({ workingDays: 0, currentDays: 0, remainingDays: 0 });

	useEffect(() => {
		const [workingDays, currentDays, remainingDays] = cycleDaysInfo(cycle.start.$date, cycle.end.$date);

		setDaysInfo({
			...daysInfo,
			workingDays: workingDays,
			currentDays: currentDays,
			remainingDays: remainingDays
		});
	}, [cycle]);

	return (
		<div className='text-center fs-5 mt-4 mb-5'>
			<p>
				<b>{global_data?.overview?.cycleStart}</b> {epochToLocalDate(cycle.start.$date, localStorage.getItem('i18nextLng'))} - 
				<b> {global_data?.overview?.cycleEnd}</b> {epochToLocalDate(cycle.end.$date, localStorage.getItem('i18nextLng'))}
			</p>

			<p>
				<b>{global_data?.overview?.cycleWorkingDays}:</b> {daysInfo.workingDays}
				{cycle.status !== 5 &&
					<Fragment>
						&nbsp;- <b>{global_data?.overview?.cycleCurrentDays}:</b> {daysInfo.currentDays} - <b>{global_data?.overview?.cycleRemainingDays}:</b> {daysInfo.remainingDays}
					</Fragment>
				}
			</p>
		</div>
	);
}

CycleDatesInfo.propTypes = {
	cycle: PropTypes.object.isRequired
};

export default CycleDatesInfo;
